export const QUERY_CUSTOM_FIELDS_ALL = "QUERY_CUSTOM_FIELDS_ALL";
export const QUERY_CUSTOM_FIELD = "QUERY_CUSTOM_FIELD";
